var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.updatesList && _vm.updatesList.length
    ? _c(
        "ul",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isLoading,
              expression: "isLoading",
            },
          ],
          staticClass: "list-group list-group-flush",
        },
        _vm._l(_vm.updatesList, function (update, index) {
          return _c(
            "li",
            {
              key: `response-item--${index}`,
              staticClass: "list-group-item update-container d-flex px-0",
            },
            [
              _c(
                "div",
                { staticClass: "update-badge pt-1 px-2" },
                [
                  _vm.updateIcon[update.type]
                    ? _c(_vm.updateIcon[update.type], {
                        tag: "component",
                        staticClass: "rb-icon-xl",
                        attrs: { title: "" },
                      })
                    : _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content:
                              update.badge === "Manufacturer"
                                ? "Manufacturer response"
                                : "Seller response",
                            "open-delay": 500,
                            disabled:
                              update.badge !== "Manufacturer" &&
                              update.badge !== "Seller",
                          },
                        },
                        [
                          _c("account-circle-icon", {
                            staticClass: "rb-icon-xl",
                            class: {
                              "text-primary": update.badge === "Manufacturer",
                              "text-info": update.badge === "Seller",
                            },
                            attrs: { title: "" },
                          }),
                        ],
                        1
                      ),
                ],
                1
              ),
              _c("div", { staticClass: "update-content flex-grow-1" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "update-header d-flex justify-content-between align-items-start mb-1",
                  },
                  [
                    _c("div", { staticClass: "update-author text-muted" }, [
                      update.badge === "Manufacturer"
                        ? _c("div", [
                            update.submitted_by
                              ? _c("div", [
                                  _c("span", [
                                    _c("span", [_vm._v("Submitted by")]),
                                    _vm._v(
                                      " " + _vm._s(update.submitted_by) + " | "
                                    ),
                                  ]),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getFormattedDate(
                                          update.submitted_ts
                                        )
                                      )
                                    ),
                                  ]),
                                ])
                              : update.posted_by
                              ? _c("div", [
                                  _c("span", [
                                    _c("span", [_vm._v("Posted by")]),
                                    _vm._v(
                                      " " + _vm._s(update.posted_by) + " | "
                                    ),
                                  ]),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getFormattedDate(update.posted_ts)
                                      )
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ])
                        : _c("div", [
                            _c("span", [
                              _vm._v(_vm._s(update.posted_by) + " | "),
                            ]),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.getFormattedDate(update.posted_ts))
                              ),
                            ]),
                          ]),
                    ]),
                  ]
                ),
              ]),
            ]
          )
        }),
        0
      )
    : _c(
        "div",
        {
          staticClass: "alert alert-light text-default",
          attrs: { role: "alert" },
        },
        [_vm._v(" No responses or updates found ")]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }